export const ita = {

    dashboard: "pannello di controllo",

    accountsReceivable: "crediti",
    customer: "Customer",
    inventory: "Inventario",
    product: "Prodotto",

    invoice: "fattura",
    quote: "citazione",
    payment: "pagamento",
    employee: "dipendente",
    admin: "amministratore",
    generalSettings: "impostazioni generali",
    paymentMode: "Metodo di pagamento",
    paymentInvoice: "Fattura di pagamento",
    role: "ruolo",
    settings: "impostazioni",
    //Customer
    "nameCompany": "Nome della ditta",

    "customerForm": {
        "header": {
            "ADD_NEW_ENTITY": 'Aggiungi nuovo cliente',
            "DATATABLE_TITLE": 'Elenco clienti',
            "ENTITY_NAME": 'cliente',
            "CREATE_ENTITY": 'Crea cliente',
            "UPDATE_ENTITY": 'Aggiorna cliente',
            "PANEL_TITLE": 'Pannello clienti',

        },
        "body" : {
           
            codeClient: "Codice",
            businessName: "Nome commerciale",
            comercialDesignation: "Designazione commerciale",
            name: "Nome",
            surName: "Cognome",
            email: "E-mail",
            phone: "Telefono",
            address:"Indirizzo"

        },
        "requiredMessages": {
            "name": "Per favore digita il tuo nome !",
            "surName": "Per favore digita il tuo cognome !",
            "email": "Per favore digita la tua email!",
            "phone": "Per favore digita il tuo numero di telefono!",
            "message": "Please let us know how can we help you.",
            "country": "Please select a country."
        },
        "invalidMessages": {
            "email": "Indirizzo email non valido!"
        },
    }

}